import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { API_BASE_URL } from '@/app/core/http/api-base-url.token';
import { ApiEnvelope } from '@/app/core/http/api-envelope.model';
import { AuthHttpClient } from '@/app/core/http/auth-http-client';
import {
  StaffChangeBatch,
  StaffChangeHistoryPage,
  StaffChangeHistoryQuery,
} from '../../models/staff-change-history.model';
import { StaffChangeHistoryRepository } from './staff-change-history.repository';

const HISTORIAL_PATH = '/staff/historial';

@Injectable()
export class StaffChangeHistoryHttpRepository extends StaffChangeHistoryRepository {
  private readonly http = inject(AuthHttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  override getPage(query: StaffChangeHistoryQuery): Observable<StaffChangeHistoryPage> {
    return this.http
      .get<ApiEnvelope<StaffChangeHistoryPage>>(`${this.baseUrl}${HISTORIAL_PATH}`, {
        params: this.toParams(query),
      })
      .pipe(map((envelope) => this.unwrap(envelope, HISTORIAL_PATH)));
  }

  override getBatch(batchId: string): Observable<StaffChangeBatch> {
    const path = `${HISTORIAL_PATH}/${batchId}`;
    return this.http
      .get<ApiEnvelope<StaffChangeBatch>>(`${this.baseUrl}${path}`)
      .pipe(map((envelope) => this.unwrap(envelope, path)));
  }

  private unwrap<T>(envelope: ApiEnvelope<T>, path: string): T {
    if (!envelope.success) {
      throw new Error(`GET ${path} respondió success: false (trace_id: ${envelope.trace_id})`);
    }
    return envelope.data;
  }

  private toParams(query: StaffChangeHistoryQuery): Record<string, string | number> {
    const params: Record<string, string | number> = {
      page: query.page,
      size: query.size,
    };

    if (query.startDate) params['startDate'] = query.startDate;
    if (query.endDate) params['endDate'] = query.endDate;
    if (query.operationType) params['operationType'] = query.operationType;
    if (query.staffType) params['staffType'] = query.staffType;
    if (query.channel) params['channel'] = query.channel;
    if (query.sortBy) params['sortBy'] = query.sortBy;
    if (query.sortOrder) params['sortOrder'] = query.sortOrder;

    return params;
  }
}
